import Boolean from './Boolean';
import Checkbox from './Checkbox';
import ContactList from './ContactList';
import Date from './Date';
import Digits from './Digits';
import Html from './Html';
// import Image from './Image';
import Lang from './Lang';
import LinkToSinlge from './LinkToSinlge';
import Number from './Number';
import Price from './Price';
import Redirect from './Redirect';
import Role from './Role';
import Schedule from './Schedule';
import StreetType from './StreetType';
import String from './String';
import Topic from './Topic';
import Var from './Var';
import LessonDay from './lessonDay';

import CourseSelect from './CourseSelect';
import DaysStatisticPlac from './DaysStatisticPlac';
import EditSettingsVillageCheckbox from './EditSettingsVillageCheckbox';
import EllipsisText from './EllipsisText';
import InputFromHw from './InputFromHW';
import LinkToSinlgeAndLang from './LinkToSinlgeAndLang';
import NewsHasAttachments from './NewsHasAttachments';
import NewsStatus from './NewsStatus';
import NewsVisibleDomains from './NewsVisibleDomains';
import NewsVisibleRoles from './NewsVisibleRoles';
import StatusHistory from './StatusHistory';
import StudentStatus from './StudentStatus';
import WolkingTime from './WolkingTime';

// import CitiesSelect from "./CitiesSelect";
// import CountrySelect from "./CountrySelect";

import { Array } from './Array';
import Discounts from './Discounts';
import DiscountsAmount from './DiscountsAmount';
import HWAge from './HWAge';
import HW_game_type from './HW_game_type';
import Minmax from './Minmax';
import StudentAgeGroup from './StudentAgeGroup';
import TeacherFullName from './TeacherFullName';
import Time from './Time';
import BirthDate from './birthDate';
import Counters from './counter';
import JournalSelect from './journal_select';
import NewEqField from './newEqFields';
import Options from './options';
import StatusCourse from './statusCourse';
import StatusSelect from './statusSelect';
import { StatusSelectQuiz } from './statusSelectQuiz';
import Week from './week';
import UserIds from './UserIds';
import StatusBook from './StatusBook';
import TextbookTopic from './TextbookTopic';
import VisitCheckbox from './VisitCheckbox';
import TagSelect from './TagSelect';
import CommentInput from './CommentInput';

export default ({ allcell, data, type, value, id, code, temporarily, label, roleId }) => {
    if (label === '№' && type === 'string') {
        return <Counters value={value} code={code} />;
    }

    switch (type) {
        case 'status_course':
            return <StatusCourse data={data} value={value} code={code} temporarily={temporarily} />;
        case 'string':
        case 'numbers_student':
        case 'counterparty.name':
        case 'cities_select':
        case 'country_select':
        case '[city]':
        case 'city.id':
        case 'city.name':
        case 'orderStatus':
        case 'gameTransactions_select':
        case 'topic_select':
            return <String data={data} value={value} code={code} temporarily={temporarily} />;
        case 'number':
            return <Number value={value} />;
        case 'minmax':
            return <Minmax id={id} data={data} code={code} temporarily={temporarily} value={value} label={label} />;
        case 'price':
            return <Price value={value} />;
        case 'lesson_day':
            return <LessonDay data={data} value={value} code={code} temporarily={temporarily} />;
        // case 'image':
        //     return <Image value={value} />;
        case 'boolean':
        case 'disabled_boolean':
        case 'boolean_select':
            return <Boolean value={value} code={code} type={type} />;
        case '[email]':
            return <ContactList value={value} prefix="mailto:" />;
        case '[phone]':
            return <ContactList value={value} prefix="tel:+" />;
        case '[url]':
            return <ContactList value={value} target="_blank" rel="noopener noreferrer" />;
        case 'workingTime':
            return <Schedule value={value} />;
        case 'redirect':
            return <Redirect value={value} />;
        case 'birth_date':
            return <BirthDate value={value} />;
        case 'date':
            return <Date value={value} code={code} />;
        case 'time':
            return <Time value={value} data={data} />;
        // case 'subdivision.id':
        //     return <NameList value={value} />;
        case 'html':
            return <Html value={value} />;
        case '[street_type]':
            return <StreetType value={value} />;
        case 'role':
            return <Role value={value} />;
        case 'checkbox':
            return <Checkbox id={id} code={code} value={value} />;
        case 'visitCheckbox':
            return <VisitCheckbox id={id} code={code} />;
        case 'tag_select':
            return <TagSelect id={id} code={code} />;
        case 'commentInput':
            return <CommentInput id={id} code={code} />;
        case 'HW-topic':
            return <Topic all={allcell} id={id} code={code} temporarily={temporarily} value={value} />;
        case 'HW-digits':
            return <Digits id={id} code={code} temporarily={temporarily} value={value} />;
        case 'lang':
            return <Lang value={value} />;
        case 'LinkToSinlge':
            return <LinkToSinlge id={id} value={value} item="123" />;
        case 'LinkToSinlgeAndLang':
            return <LinkToSinlgeAndLang id={id} value={value} data={data} />;
        case 'new_eq':
            return <NewEqField id={id} code={code} data={data} temporarily={temporarily} value={value} label={label} />;
        case 'InputHW':
            return (
                <InputFromHw id={id} code={code} data={data} temporarily={temporarily} value={value} label={label} />
            );
        case 'HW_game_type':
            return (
                // eslint-disable-next-line
                <HW_game_type id={id} code={code} temporarily={temporarily} value={value} />
            );
        case 'course_select':
            return <CourseSelect id={id} code={code} temporarily={temporarily} value={value} />;
        case 'status_select':
        case 'status_select_teacher':
            return (
                <StatusSelect
                    id={id}
                    code={code}
                    temporarily={temporarily}
                    value={value}
                    type={type}
                    roleId={roleId}
                    data={data}
                />
            );
        case 'daysStatisticPlac':
            return <DaysStatisticPlac id={id} code={code} temporarily={temporarily} value={value} />;
        case 'status_history':
        case 'date_group_history':
            return <StatusHistory id={id} code={code} type={type} temporarily={temporarily} value={value} />;
        case 'discounts':
            return (
                <Discounts id={id} data={data} allcell={allcell} code={code} temporarily={temporarily} value={value} />
            );
        case 'discounts-amount':
            return <DiscountsAmount id={id} code={code} temporarily={temporarily} value={value} />;
        case 'hw_age':
            return <HWAge id={id} code={code} temporarily={temporarily} value={value} />;
        case 'varibles':
            return <Var id={id} all={allcell} code={code} temporarily={temporarily} value={value} />;
        case 'optionsHW':
            return <Options id={id} code={code} temporarily={temporarily} value={value} />;
        case 'week':
            return <Week id={id} code={code} temporarily={temporarily} value={value} />;
        case 'journal_select':
            return <JournalSelect id={id} code={code} temporarily={temporarily} value={value} />;
        case 'array':
            return <Array value={value} code={code} />;

        case 'array_roles':
            return <NewsVisibleRoles value={value} />;

        case 'array_domains':
            return <NewsVisibleDomains value={value} />;

        case 'array_files':
            return <NewsHasAttachments value={value} />;

        case 'ellipsisText':
            return <EllipsisText value={value} />;

        case 'news_status':
            return <NewsStatus value={value} />;
        case 'editSettingsVillageCheckbox':
            return <EditSettingsVillageCheckbox id={id} code={code} value={value} />;
        case 'wolking_time_select':
            return <WolkingTime value={value} />;
        case 'status_select_quiz':
            return <StatusSelectQuiz value={value} />;
        case 'studentStatus':
            return <StudentStatus value={value} />;
        case 'teachersNameselect':
        case 'teachers_select':
            return <TeacherFullName value={value} />;
        case 'age_select':
            return <StudentAgeGroup value={value} />;
        case 'user_ids_array':
            return <UserIds value={value} />;
        case 'status':
            return <StatusBook value={value} />;
        case 'textbook':
            return <TextbookTopic value={value} />;


        default:
            return <>{value}</>;
    }
};
